import { MSPaneContainer } from "../../ms_front_lib/app/MSPaneContainer";
import { MainCss } from "./Main.css";
import { is_on_mobile } from "../app";
import { isIOS } from "../app";
import { Prog } from "../utils/Prog";
import { MSDropDown } from "../../ms_front_lib/components/MSDropDown";
import { MSSidebar } from "../../ms_front_lib/components/MSSidebar";
import { MSIcon } from "../../ms_front_lib/components/MSIcon";
import { MSModal } from "../../ms_front_lib/components/MSModal";
import { MSSelect } from "../../ms_front_lib/forms/MSSelect";

export class Main extends MSPaneContainer {
    constructor() {
        super("main")
        this.site_id = gl_config.site_id;
        this.nav_items = [];
        this.logo_url = gl_config.logo_url ? gl_config.logo_url.replace("x48","x75") : "";
        this.website_active = gl_config.type == "site" && gl_config.site.website_active ? gl_config.site.website_active : gl_config.type == "site" ? false : true;
        this.list_files = [];
        this.auth_token = gl_app.authToken();

        this.website_in_production = gl_config.type == "site" && gl_config.site.website_in_production ? gl_config.site.website_in_production : gl_config.type == "site" ? false : true;
        const hostname = window.location.hostname; // www.ticketingcine.com

        // console.log(this.website_active)
        // console.log(window.location.hostname)
        // console.log(this.website_in_production)

        // Si cinéma en imsWeb et avec une config des menus, sinon menus par defaut conditionnés par rapport à la config (confiserie, abo, fidélité, etc...)
        // console.log(gl_config.website.menus)
        if(this.website_active && (this.website_in_production || hostname != "www.ticketingcine.com") && gl_config.website.menus) {
            // On va d'abord afficher les item qui sont en position "external"
            const externals_items = gl_config.website.menus.filter(m => m.position.type == "external");
            const internals_items = gl_config.website.menus.filter(m => m.position.type == "internal");

            // console.log("externals_items", externals_items)
            // console.log("internals_items", internals_items)

            externals_items.forEach(async (item) => {
                if(!item.active){
                    return;
                }
                if(item.id == "confiserie" && (!gl_ems_config.data_cinema.confiserie || !gl_ems_config.data_cinema.confiserie.active)){
                    return;
                }
                if(item.id == "subscription" && (gl_ems_config.data_cinema.mode_paiement?.carte_abonne?.actif == 0 && !gl_ems_config.data_cinema.vente_carte_abo)){
                    return;
                }
                if(item.id == "fidelity" && (!gl_ems_config.data_cinema.fideliteKdo && !gl_ems_config.data_cinema.vente_carte_fidelite)){
                    return;
                }
                if(item.id == "refund" && !gl_ems_config.data_cinema.can_cancel){
                    return;
                }

                let items = [];
                internals_items.forEach(async (int_items) => {
                    if(int_items.active && int_items.position.parent == item.id){
                        let href = null;
                        if(int_items.link.type == "internal" && int_items.link.page_id){
                            href = "#"+int_items.link.page_id;
                        }else if(int_items.link.type == "external"){
                            href = int_items.link.url ? int_items.link.url : "#";
                        }else if(int_items.link.type == "file"){
                            href = null;
                        }else if(int_items.link.type == "auto_program"){
                            href = "#show_prog_pdf";
                        }

                        items.push({
                            href : href,
                            text : int_items.label,
                            order : int_items.position.order,
                            target : (int_items.link.type == "internal" || int_items.link.type == "auto_program") ? "_self" : "_blank"
                        })

                        let file_url = null;
                        if(int_items.link.type == "file"){
                            const res_api_file = await gl_api.get_website_docs({"docs" : ["file_"+int_items.link.file_id]});
                            Object.values(res_api_file.docs).forEach(file => {
                                // Si le fichier n'est pas déjà dans notre tableau global de fichiers, on le rajoute
                                file_url = file.media_url;
                            });

                            // On met à jour le href dans le tableau items
                            items.forEach(item => {
                                if(item.href == href && item.text == int_items.label){
                                    item.href = file_url;
                                }
                            });
                        }
                    }
                });

                // console.log("item", item)
                // console.log("items", items)
                // if(items.length <= 0){
                //     items = null;
                // }

                let file_url = null;
                if(item.link.type == "file"){
                    const res_api_file = await gl_api.get_website_docs({"docs" : ["file_"+item.link.file_id]});
                    Object.values(res_api_file.docs).forEach(file => {
                        // Si le fichier n'est pas déjà dans notre tableau global de fichiers, on le rajoute
                        file_url = file.media_url;
                    });
                }

                let href = null;
                if(item.link.type == "internal" && item.link.page_id){
                    href = "#"+item.link.page_id;
                }else if(item.link.type == "external"){
                    href = item.link.url ? item.link.url : "#";
                }else if(item.link.type == "file"){
                    href = file_url;
                }else if(item.link.type == "auto_program"){
                    href = "#show_prog_pdf";
                }
                if(!href && items.length <= 0){
                    return;
                }
                this.nav_items.push({
                    href : href,
                    text : item.label,
                    items : items.length <= 0 ? null : items,
                    order : item.position.order,
                    target : (item.link.type == "internal" || item.link.type == "auto_program") ? "_self" : "_blank",
                    highlight : item.highlight ? item.highlight : false
                });
            });
        }else{
            // this.nav_items = [
            //     {
            //         href: "#home",
            //         text: _l("Accueil"),
            //         id: "home"
            //     },
            //     {
            //         href: "#schedule",
            //         text: _l("Horaires"),
            //         id: "schedule"
            //     }
            // ];
            // console.log(gl_ems_config)
            if(gl_config.type == "site"){
                this.nav_items.push({
                    href: "#schedule",
                    text: _l("Horaires"),
                    id: "schedule"
                });
                if (gl_ems_config.data_cinema.confiserie && gl_ems_config.data_cinema.confiserie.active) {
                    this.nav_items.push({
                        href: "#showconfiserie",
                        text: _l("Confiserie"),
                        id: "confiserie"
                    });
                }
                if(gl_ems_config.data_cinema.mode_paiement?.carte_abonne?.actif == 1 || gl_ems_config.data_cinema.vente_carte_abo) {
                    this.nav_items.push({
                        href: "#subscription",
                        text: _l("Abonnement"),
                        id: "subscription"
                    });
                }
                if(gl_ems_config.data_cinema.fideliteKdo || (gl_ems_config.data_cinema.list_fidelity && gl_ems_config.data_cinema.list_fidelity.length > 0) || gl_ems_config.data_cinema.vente_carte_fidelite) {
                    this.nav_items.push({
                        href: "#fidelity",
                        text: _l("Fidélité"),
                        id: "fidelity"
                    });
                }
                if(gl_ems_config.data_cinema.can_cancel) {
                    this.nav_items.push({
                        href: "#refund",
                        text: _l("Remboursement"),
                        id: "refund"
                    });
                }
            }
        }

        this.num_cine_selected = localStorage.getItem("chain_num_cine_selected") ? localStorage.getItem("chain_num_cine_selected"):  null; // EMS9997, EMS9996, ...
        if(this.num_cine_selected === "undefined"){
            this.num_cine_selected = null;
        }
    }

    $create(iQuery) {
        let $res = $("<div/>").addClass("container-fluid");
            var $header = $("<header/>").appendTo($res);

            if(is_on_mobile()){
                this.create_mobile_navbar({
                    "$parent" : $header
                });
            }else{
                this.create_navbar({
                    "$parent" : $header
                });
            }

            var $section = $("<section/>").addClass("main-section").appendTo($res);
                var $pane_container = $("<div/>").attr({ "id": "pane_container" }).appendTo($section);

            this.create_footer({
                "$parent" : $res
            });
            this.$create_mobile_app_footer({
                "$parent" : $res
            });

        this.inputContainer = $("<div/>").addClass(is_on_mobile() ? "mobile-input-container" : "input-container").insertAfter($res.find("#nav")).attr({"id":"container_search_movie"}).toggle();
            this.searchMovieInput = $("<input/>").addClass(is_on_mobile() ? "mobile-search-movie-input" : "search-movie-input").attr({ type: "search", placeholder: "Rechercher un film", id: "search-movie-input", }).appendTo(this.inputContainer);
            this.resultList = $("<ul/>").addClass(is_on_mobile() ? "mobile-result-list" : "result-list").appendTo(this.inputContainer);

        this.$m_pane_container = $pane_container;
        return $res;
    }

    onAfterCreate(iQuery) {
        $(".main-section").on("scroll", (e) => {
            // Coloration de desktop-nav
            if($(".desktop-nav").length > 0){
                if(e.currentTarget.scrollTop > 50){
                    $(".desktop-nav").addClass("colored");
                }else {
                    $(".desktop-nav").removeClass("colored");
                }
            }
            if($(".mobile-nav").length > 0){
                if(e.currentTarget.scrollTop > 50){
                    $(".mobile-nav").addClass("colored");
                }else {
                    $(".mobile-nav").removeClass("colored");
                }
            }

            if ($(".slider_container.slider_date").length > 0) {
                // const limit_pane_schedule = $("#nav").length > 0 ? $("#nav").height() : $("#mobile-nav").length > 0 ? $("#mobile-nav").height() : 0;
                // const limit_pane_movie_show = $("#wrap_movie_details").height();
                if (e.currentTarget.scrollTop > 200) {
                    $("div[id*=pane_page_schedule] .wrap_tools_prog").addClass("fixed");
                    $("div[id*=pane_page_schedule] #wrap_movies_selected_date").css({"margin-top":"200px"});
                } else if (e.currentTarget.scrollTop < 200) {
                    $("div[id*=pane_page_schedule] .wrap_tools_prog").removeClass("fixed");
                    $("div[id*=pane_page_schedule] #wrap_movies_selected_date").css({"margin-top":"0"});
                }

                // if (e.currentTarget.scrollTop > limit_pane_movie_show) {
                //     $("div[id*=pane_page_show_movie] .wrap_tools_prog").addClass("fixed");
                // } else if (e.currentTarget.scrollTop < limit_pane_movie_show) {
                //     $("div[id*=pane_page_show_movie] .wrap_tools_prog").removeClass("fixed");
                // }
                // if (e.currentTarget.scrollTop > 0) {
                //     $("div[id*=pane_page_show_movie] .wrap_tools_prog").addClass("fixed");
                // } else if (e.currentTarget.scrollTop <= 0) {
                //     $("div[id*=pane_page_show_movie] .wrap_tools_prog").removeClass("fixed");
                // }
            }
        })

        if (this.m_prog && this.m_prog.expiration_ms > Date.now()) {
            console.log("Program is up to date");
        } else if(gl_config.type == "site"){
            gl_api.getProg().then((prog) => {
                // console.log(prog)
                this.m_prog = prog;
                const events = prog.schedule.events;
                // !!!!! QuotaExceededError: Failed to execute 'setItem' on 'Storage': Setting the value of 'events' exceeded the quota. !!!!!
                // localStorage.setItem("events",JSON.stringify(events))
                this.searchInput(events);
            })
            .catch((err) => {
                console.log(err)
                Swal.fire({
                    icon: "warning",
                    title: _l("Récupération de la programmation"),
                    showCloseButton: true,
                    text: _l(err.data ? err.data.message : err),
                    heightAuto: false,
                    scrollbarPadding: false,
                    allowOutsideClick: false,
                    customClass: {
                        icon: "align-items-center"
                    }
                }).then((result) => {
                    
                });
                return;
            });
            $("#wrap_search_bar_chain_cinema").remove();
        } else if(gl_config.type == "chain") {
            gl_api.get_events().then((chain_events) => {
                // console.log("chain_events", chain_events)
                // localStorage.setItem("chain_events",JSON.stringify(chain_events))
            })
            .catch((err) => {
                console.log(err)
                gl_api.n_log('Main.js - Récupération des films du groupe => ',_l(err.data ? err.data.message : err));
                // Swal.fire({
                //     icon: "warning",
                //     title: _l("Récupération des films du groupe"),
                //     showCloseButton: true,
                //     text: _l(err.data ? err.data.message : err),
                //     heightAuto: false,
                //     scrollbarPadding: false,
                //     allowOutsideClick: false,
                //     customClass: {
                //         icon: "align-items-center"
                //     }
                // }).then((result) => {
                    
                // });
                // return;
            });

            this.$create_search_bar_chain_cinema({
                "$parent" : $("#wrap_search_bar_chain_cinema")  
            });
        }

        this.updateUserMenu();
        this.hideNav();
        this.manageSideBar();
        this.switchFooter();

        
        // On regarde dans la config si on doit appliquer un flou à la navbar
        if(gl_config.website.style && gl_config.website.style.navbar_blur && gl_config.website.style.navbar_blur > 0){
            $("nav").css({
                "backdrop-filter":"blur("+gl_config.website.style.navbar_blur+"px)",
            });
        }

        $("nav")
        .on("mouseenter",(e) => {
            $(e.currentTarget).addClass("hover");
        })
        .on("mouseleave",(e) => {
            $(e.currentTarget).removeClass("hover");
        })
    }

    create_navbar(iParam) {
        // console.log("create_navbar", iParam)
        var $d_nav = $("<nav/>").addClass("desktop-nav").attr({ "id": "nav" }).appendTo(iParam.$parent);
            var $list = $("<ul/>").addClass("sidebar").appendTo($d_nav);
                var $item = $("<li/>").addClass("d-flex").attr({ "id": "cross" }).appendTo($list);
                    var $link = $("<a/>").addClass("ms-auto mt-1").appendTo($item);
                        var $icon = $("<i/>").addClass("fa-solid fa-xmark text-white").appendTo($link);
                MSSidebar.create({
                    items: this.nav_items
                }).appendTo($list);

            var $list = $("<ul/>").attr({"id":"list_navbar"}).addClass("pe-2").appendTo($d_nav);
                var $item = $("<li/>").addClass("").attr({ "id": "cross" }).appendTo($list);
                    var $link = $("<a/>").attr({ "href": gl_config.website.home_page_id ? "#"+gl_config.website.home_page_id : "#home"}).appendTo($item);
                        var $img = $("<img/>").addClass("site_logo").attr({ "src": this.logo_url , "alt":"Logo"}).appendTo($link);

                var $wrap=$("<div/>").addClass("me-auto").attr({"id":"wrap_nav_items"}).appendTo($list);
                    var $ul = $("<ul/>").attr({"id":"desktop-navbar-list"}).appendTo($wrap);
                this.nav_items.forEach(item => {
                    var $item = $("<li/>").addClass("hide-small-screen").appendTo($ul).css({"order":item.order});
                        var $link = $("<a/>").attr({ "href": item.href, "id": item.id, "target": item.target }).text(item.text).appendTo($item);
                        if (item.icon) {
                            var $icon=$("<img/>").addClass("icon icon_svg").attr({"src":item.icon, "alt":"Icône"}).appendTo($link);
                        }
                    if(item.items){
                        $item.addClass("with_sub_items")
                        let $svg_container = $("<div/>").addClass("svg_container icon icon_svg").html(gl_app.list_icons_svg.filter(icon => icon.id == "regular_chevron_down")[0].svg_text).appendTo($link);

                        // tri des sous menus par ordre (définit dans le BO ims)
                        item.items.sort(function (a, b) {
                            if (a.order > b.order) {
                                return 1;
                            };
                            if (a.order < b.order) {
                                return -1;
                            };
                            return 0;
                        });
                
                        $link.addClass("dropdown-toggle position-relative pointer");
                        $link.removeAttr("href");
                        $link.attr({"data-bs-toggle":"dropdown"});
                        MSDropDown.create({
                            id: item.id+"_drop_down",
                            items: item.items,
                        }).appendTo($item);
                    }

                    if(item.highlight){
                        $item.addClass("highlight")
                    }
                });
                
                if(gl_config.type == "site"){
                    // Si pas site imsWeb, on rajoute nom et ville cinéma dans la navbar
                    if(!gl_config.site.website_active){
                        var $item = $("<li/>").addClass("wrap_cinema_name").appendTo($list);
                            $("<div/>").addClass("cinema_name").text(gl_config?.site?.name).appendTo($item);
                            $("<div/>").addClass("cinema_city").text(gl_config?.site?.address?.city).appendTo($item);
                    }

                    // Bouton customisable depuis le BO
                    if(gl_config.website.action_button && gl_config.website.action_button.active){
                        var $item = $("<li/>").addClass("h-auto li_navbar_action_button").appendTo($list);
                        this.$fill_navbar_action_button({
                            "data" : gl_config.website.action_button,
                            "$parent" : $item
                        });
                    }

                    // Si vente de places dématérialisées, on affiche icone compte et panier
                    if(gl_ems_config?.data_cinema?.demat){
                        var $item = $("<li/>").addClass("mb-2").appendTo($list);
                            var $link = $("<a/>").addClass("user_menu").attr({ "href": "#login", "id": "login", "aria-label":"Connexion/accès au compte"}).appendTo($item);

                        var $item = $("<li/>").addClass("mb-2").appendTo($list);
                            var $link = $("<a/>").addClass("").attr({ "href": "#cart", "id": "cart", "aria-label":"Panier"}).appendTo($item);
                                var $qty=$("<div/>").addClass("qty nb_item nb_item_basket").appendTo($link);
                                var $icon = $("<i/>").addClass("fa-solid fa-basket-shopping").appendTo($link);
                    }
                }

                // Si site de type "chain", on ajoute la barre de recherche des cinémas dans la navbar
                var $div=$("<div/>").addClass("").attr({"id":"wrap_search_bar_chain_cinema"}).appendTo($list);

            var $item = $("<li/>").addClass("").attr({ "id": "hamburger" }).appendTo($list);
                var $link = $("<a/>").appendTo($item);
                    var $icon = $("<i/>").addClass("fa-solid fa-bars").appendTo($link);
    }

    create_mobile_navbar(iParam) {
        // console.log("create_mobile_navbar")
        let item_m_nav = Object.assign([], this.nav_items);
        if(gl_config.type == "site"){
            item_m_nav.push(
            {
                icon: "",
                text: _l("C.G.V"),
                href: "#cgv",
            },
            {
                icon: "",
                text: _l("Mentions légales"),
                href: "#legal",
            },
            {
                icon: "",
                text: _l("Contact"),
                href: "#contact",
                // href: this.site_id.substring(0,5) == "EMS99" ? "#contact" : "",
                // onclick: () => this.ModalContacte()
            })
        }
                
        var $mobile_nav = $("<nav/>").addClass("mobile-nav").attr({ "id": "mobile-nav" }).appendTo(iParam.$parent);
            // Si app mobile IOS, on doit créer une barre juste pour y mettre un bouton "back"
            if(gl_mobile_app && isIOS()){
                var $wrap=$("<div/>").addClass("wrap_ios_bar").appendTo($mobile_nav).on("click",() => {
                    window.history.back()
                }).hide();
                    var $flexbox=$("<div/>").addClass("d-flex").appendTo($wrap);
                        var $svg_container = $("<div/>").addClass("svg_container icon icon_svg").html(gl_app.list_icons_svg.filter(icon => icon.id == "regular_chevron_left")[0].svg_text).appendTo($flexbox);  
            }

            var $item = $("<div/>").addClass("ms-1 me-auto").addClass(gl_config.type == "site" ? "wrap_site_logo" : "wrap_chain_logo").attr({ "id": "cross" }).appendTo($mobile_nav);
                var $link = $("<a/>").attr({ "href": gl_config.website.home_page_id ? "#"+gl_config.website.home_page_id : "#home"}).appendTo($item);
                    var $img = $("<img/>").addClass("site_logo").attr({ "src": this.logo_url , "alt":"Logo"}).appendTo($link);

            if(gl_config.type == "site"){
                // Si pas site imsWeb, on rajoute nom et ville cinéma dans la navbar
                if(!gl_config.site.website_active){
                    var $item = $("<li/>").addClass("wrap_cinema_name").appendTo($mobile_nav);
                        $("<div/>").addClass("cinema_name").text(gl_config?.site?.name).appendTo($item);
                        $("<div/>").addClass("cinema_city").text(gl_config?.site?.address?.city).appendTo($item);
                }

                // Bouton customisable depuis le BO (dropdown)
                if(gl_config.website.action_button && gl_config.website.action_button.active){
                    var $item = $("<div/>").addClass("mx-1 my-auto h-auto li_navbar_action_button").appendTo($mobile_nav);
                    this.$fill_navbar_action_button({
                        "data" : gl_config.website.action_button,
                        "$parent" : $item
                    });
                }

                // Si vente de places dématérialisées, on affiche icone compte et panier
                if(gl_ems_config?.data_cinema?.demat){
                    var $item = $("<div/>").addClass("ms-md-3 me-3").addClass(!gl_config.site.website_active ? "ms-auto" : "").attr({"id":"box_user_menu"}).appendTo($mobile_nav);
                        var $link = $("<a/>").addClass("user_menu").attr({ "href": "#login", "id": "login", "aria-label":"Connexion/accès au compte"}).appendTo($item);
                    
                    var $item = $("<div/>").addClass("mx-1").attr({"id":"box_basket"}).appendTo($mobile_nav);
                        var $link = $("<a/>").addClass("position-relative").attr({ "href": "#cart", "id": "cart", "aria-label":"Panier"}).appendTo($item);
                            var $qty=$("<div/>").addClass("qty nb_item nb_item_basket").appendTo($link);
                            var $icon = $("<i/>").addClass("fa-solid fa-basket-shopping").appendTo($link);
                }
            }

            // Si site de type "chain", on ajoute la barre de recherche des cinémas dans la navbar
            var $div=$("<div/>").addClass("").attr({"id":"wrap_search_bar_chain_cinema"}).appendTo($mobile_nav);

            var $item = $("<div/>").addClass("ms-3 me-3").attr({ "id": "mobile-hamburger" }).appendTo($mobile_nav);
                var $link = $("<a/>").appendTo($item);
                    var $icon = $("<i/>").addClass("fa-solid fa-bars").appendTo($link);

                    const collapseElementList = document.querySelectorAll('.collapse')
                    const collapseList = [...collapseElementList].map(collapseEl => new bootstrap.Collapse(collapseEl));

        // var $mobile_nav = $("<nav/>").addClass("mobile-nav").attr({ "id": "mobile-nav" }).appendTo(iParam.$parent);
        var $m_sidebar = $("<div/>").addClass("mobile-sidebar").appendTo(iParam.$parent);
            var $flexbox = $("<div/>").addClass("flexbox d-flex flex-column flex-1 w-100").appendTo($m_sidebar);
                var $wrap = $("<div/>").addClass("ms-auto").appendTo($flexbox);
                    var $link = $("<a/>").appendTo($wrap);
                        var $icon = $("<i/>").addClass("fa-solid fa-xmark text-white").appendTo($link);
                MSSidebar.create({
                    items: item_m_nav
                }).appendTo($flexbox);
                // if(this.site_id.substring(0,5) != "EMS99"){
                //     $m_sidebar.find("a").each((i, el) => {
                //         if ($(el).text().trim() === _l("Contact")) {
                //             $(el).on("click", () => this.ModalContacte());
                //         }
                //     });
                // }
                // Footer

                var $wrap = $("<div/>").addClass("mt-auto py-2").appendTo($flexbox);
                    var $item = $("<div/>").addClass("").appendTo($wrap);
                        var $wrap = $("<div/>").addClass("d-flex justify-content-center text-center flex-column").appendTo($item);
                            if(this.site_id.substring(0,5) == "EMS99"){
                                var $span = $("<span/>").addClass("text-center").text("Version "+gl_version).appendTo($wrap);
                            }
                            var $text = $("<span/>").text(_l("Copyright ©") + moment().format("YYYY") + " - Tous droits réservés.").appendTo($wrap);
                            var $link = $("<a/>").addClass("copyright-link").attr({ "href": "javascript:gl_core.open_external_url('https://www.monnaie-services.com')" }).text(_l("Monnaie Services")).appendTo($wrap);
    }

    create_footer(iParam) {
        var $footer = $("<footer/>").addClass("footer d-flex flex-row py-2").appendTo(iParam.$parent);
            if(gl_config.type == "site"){
                // if(this.site_id.substring(0,5) == "EMS99"){
                //     var $link = $("<a/>").attr({ "href": "#contact" }).text(_l("Contact")).appendTo($footer);
                // }else{
                //     var $link = $("<span/>").addClass("footer-contact").text(_l("Contact")).on("click", () => this.ModalContacte()).appendTo($footer);
                // }
                var $link = $("<a/>").attr({ "href": "#contact" }).text(_l("Contact")).appendTo($footer);
                    var $span = $("<span/>").addClass("mx-2").text("•").appendTo($footer);
                var $link = $("<a/>").attr({ "href": "#cgv" }).text(_l("C.G.V")).appendTo($footer);
                    var $span = $("<span/>").addClass("mx-2").text("•").appendTo($footer);
                // var $link = $("<a/>").attr({ "href": "#info" }).text(_l("Infos")).appendTo($footer);
                //     var $span = $("<span/>").addClass("mx-2").text("•").appendTo($footer);
                var $link = $("<a/>").attr({ "href": "#legal" }).text(_l("Mentions légales")).appendTo($footer);
                    var $span = $("<span/>").addClass("mx-2").text("•").appendTo($footer);
            }

            var $wrap = $("<div/>").addClass("d-flex").appendTo($footer);
                var $text = $("<span/>").text(_l("Copyright ©") + moment().format("YYYY")).appendTo($wrap);
                var $link = $("<a/>").addClass("copyright-link mx-1").attr({ "href": "javascript:gl_core.open_external_url('https://www.monnaie-services.com')" }).text(_l("Monnaie Services")).appendTo($wrap);
                var $text = $("<span/>").text(_l("- Tous droits réservés.")).appendTo($wrap);
    }

    $create_mobile_app_footer(iParam){
        const $parent = iParam.$parent;
        var $footer = $("<footer/>").addClass("mobile-app-footer").appendTo(iParam.$parent);
            var $row=$("<div/>").addClass("row justify-content-around").attr({"id":"row_icons"}).appendTo($footer);
                switch(gl_config.theme.id){
                    case "megarama":
                        var $col=$("<div/>").addClass("col-3 d-flex justify-content-center").appendTo($row).on("click", () => {
                            var home_page_id = gl_config.website && gl_config.website.home_page_id ? gl_config.website.home_page_id : "home";
                            window.location.href = "#"+home_page_id;
                        });
                            var $flexbox=$("<div/>").addClass("d-flex flex-column").appendTo($col);
                                var $svg_container = $("<div/>").addClass("svg_container icon icon_svg mx-auto").html(gl_app.list_icons_svg.filter(icon => icon.id == "brand_megarama")[0].svg_text).appendTo($flexbox);  
                                var $label=$("<div/>").addClass("label font-0_7").text(_l("Accueil")).appendTo($flexbox);

                        if(gl_config.type == "site"){
                            var $col=$("<div/>").addClass("col-3 d-flex justify-content-center").appendTo($row).on("click", () => {
                                if(!this.auth_token){
                                    window.location.href = "#login";
                                }else{
                                    window.location.href = "#account";
                                }
                            });
                                var $flexbox=$("<div/>").addClass("d-flex flex-column").appendTo($col);
                                    var $svg_container = $("<div/>").addClass("svg_container icon icon_svg mx-auto").html(gl_app.list_icons_svg.filter(icon => icon.id == "ticket_megarama")[0].svg_text).appendTo($flexbox);
                                    var $label=$("<div/>").addClass("label font-0_7").text(_l("Billets")).appendTo($flexbox);
                        }

                        var $col=$("<div/>").addClass("col-3 d-flex justify-content-center").appendTo($row);
                            var $flexbox=$("<div/>").addClass("d-flex flex-column").appendTo($col);
                                var $svg_container = $("<div/>").addClass("svg_container icon icon_svg mx-auto").html(gl_app.list_icons_svg.filter(icon => icon.id == "search_megarama")[0].svg_text).appendTo($flexbox);
                                var $label=$("<div/>").addClass("label font-0_7").text(_l("Recherche")).appendTo($flexbox);

                        // Affichage de la recherche film
                        $col.on("click",() => {
                            // var $search=$("<div/>").addClass("search-bar-movie d-flex").attr({"id":"mobile_search_bar_movie"}).insertBefore($(".mobile-app-footer #row_icons"));
                            //     var $input=$("<input/>").addClass("search-movie-input").attr({ type: "search", placeholder: _l("Rechercher un film"), id: "search-movie-input-mobile", }).appendTo($search);
                        });
                        break;
                    default:
                        var $col=$("<div/>").addClass("col-3 d-flex justify-content-center").appendTo($row).on("click", () => {
                            var home_page_id = gl_config.website && gl_config.website.home_page_id ? gl_config.website.home_page_id : "home";
                            window.location.href = "#"+home_page_id;
                        });
                            var $flexbox=$("<div/>").addClass("d-flex").appendTo($col);
                                var $svg_container = $("<div/>").addClass("svg_container icon icon_svg").html(gl_app.list_icons_svg.filter(icon => icon.id == "regular_house_blank")[0].svg_text).appendTo($flexbox);  

                        var $col=$("<div/>").addClass("col-3 d-flex justify-content-center").appendTo($row).on("click", () => {
                            window.location.href = "#schedule";
                        });
                            var $flexbox=$("<div/>").addClass("d-flex").appendTo($col);
                                var $svg_container = $("<div/>").addClass("svg_container icon icon_svg").html(gl_app.list_icons_svg.filter(icon => icon.id == "regular_clock")[0].svg_text).appendTo($flexbox);  

                        // Si vente de places dématérialisées, on affiche icone compte et panier
                        if(gl_ems_config?.data_cinema?.demat){
                            var $col=$("<div/>").addClass("col-3 d-flex justify-content-center").appendTo($row).on("click", () => {
                                window.location.href = "#cart";
                            });
                                var $flexbox=$("<div/>").addClass("d-flex").attr({"id":"box_basket"}).appendTo($col);
                                    var $svg_container = $("<div/>").addClass("svg_container icon icon_svg").html(gl_app.list_icons_svg.filter(icon => icon.id == "regular_basket_shopping")[0].svg_text).appendTo($flexbox);  
                                    var $qty=$("<div/>").addClass("qty nb_item nb_item_basket").appendTo($flexbox);

                            var $col=$("<div/>").addClass("col-3 d-flex justify-content-center").appendTo($row).on("click", () => {
                                if(!this.auth_token){
                                    window.location.href = "#login";
                                }
                            });
                                var $flexbox=$("<div/>").addClass("d-flex").appendTo($col);
                                    if(!this.auth_token){
                                        var $svg_container = $("<div/>").addClass("svg_container icon icon_svg").html(gl_app.list_icons_svg.filter(icon => icon.id == "regular_circle_user")[0].svg_text).appendTo($flexbox);
                                    }else{
                                        let avatar_path = this.auth_token.user.settings.avatar;
                                        if(!this.auth_token.user.settings || !this.auth_token.user.settings.avatar){
                                            avatar_path = "classiques/1.png"
                                        }
                                        var $link=$("<a/>").addClass("dropdown-toggle").attr({"data-bs-toggle":"dropdown", "id":"link_account_avatar"}).appendTo($flexbox);
                                            var $avatar=$("<img/>").addClass("avatar mx-auto").attr({"src":"https://static.monnaie-services.com/www-img/avatar/"+avatar_path}).appendTo($link);

                                        const dropdownItems = [
                                            {
                                                // icon: "https://static.monnaie-services.com/fontawesome/svgs/regular/user.svg",
                                                text: _l("Mon Compte"),
                                                href: "#account",
                                            },
                                            "",
                                            {
                                                // icon: "https://static.monnaie-services.com/fontawesome/svgs/regular/right-from-bracket.svg",
                                                text: _l("Deconnexion"),
                                                href: "##logout",
                                            },
                                        ];
                                        MSDropDown.create({
                                            id: "mobile_app_user_menu_drop_down",
                                            items: dropdownItems,
                                        }).appendTo($flexbox);
                                    }                            
                        }
                        break;
                }

        if(isIOS()){
            $footer.addClass("ios");
        }
    }

    $create_search_bar_chain_cinema(iParam){
        // console.log("$create_search_bar_chain_cinema", iParam, this.num_cine_selected);
        const $parent = iParam.$parent;

        if(gl_config.chain.sites.filter(site => site.id == this.num_cine_selected).length <= 0){
            this.num_cine_selected = null;
            localStorage.setItem("chain_num_cine_selected", null);
        }

        let text_input = this.num_cine_selected && this.num_cine_selected != "null" ? gl_config.chain.sites.filter(site => site.id == this.num_cine_selected)[0].address.city + " - " + gl_config.chain.sites.filter(site => site.id == this.num_cine_selected)[0].name : _l("Tous les cinémas");

        var $div=$("<div/>").addClass("flexbox").appendTo($parent);
            var $text=$("<span/>").addClass("text").text(text_input).appendTo($div);
            var $svg_container = $("<div/>").addClass("svg_container icon icon_svg").html(gl_app.list_icons_svg.filter(icon => icon.id == "regular_chevron_down")[0].svg_text).appendTo($div);


        $div.on("click",async (e) => {
            $div.addClass("open");
            e.stopPropagation();
            // Si liste existant, on ferme la liste
            if($(".search_box_list_chain_cinemas").length > 0){
                $(".search_box_list_chain_cinemas").remove();
                $div.removeClass("open");
                return;
            }
            
            var $box_list_cinemas = $("<div/>").addClass("search_box_list_chain_cinemas").insertBefore($(".main-section"));
                var $list = $("<ul/>").addClass("list-unstyled").appendTo($box_list_cinemas);
                    var $item = $("<li/>").addClass("d-flex item_cinema").appendTo($list);
                        var $name=$("<span/>").addClass("cinema_name").text(_l("Sans cinémas spécifiques")).appendTo($item);
                    $item.on("click",() => {
                        this.num_cine_selected = null;
                        localStorage.setItem("chain_num_cine_selected", null);
                        $text.text(_l("Tous les cinémas"));
                        $box_list_cinemas.remove();
                        // On recharge la page
                        window.location.reload();
                    });

                // Si cinéma à proximité, on met un diviseur
                var $name=$("<div/>").addClass("divider").text(_l("A proximité")).appendTo($box_list_cinemas);
                var $list = $("<ul/>").addClass("list-unstyled").attr({"id":"nearby_cinemas"}).appendTo($box_list_cinemas);

                let sites_near = await gl_app.get_nearby_cinemas() ?? [];

                if(sites_near && sites_near.length > 0){
                    sites_near.forEach(site => {
                        var $item = $("<li/>").addClass("d-flex item_cinema").appendTo(nearby_cinemas);
                            var $name=$("<span/>").addClass("cinema_name").text(site.site.address.city + " - " + site.site.name).appendTo($item);
                            var $distance=$("<span/>").addClass("distance ms-auto").text(site.distance < 1 ? Math.round(site.distance*1000)+" m" : site.distance.toFixed(1)+" km").appendTo($item);
                        $item.on("click",() => {
                            this.num_cine_selected = site.site.id;
                            localStorage.setItem("chain_num_cine_selected", site.site.id);
                            $text.text(site.site.address.city + " - " + site.site.name);
                            $box_list_cinemas.remove();
                            // On recharge la page
                            window.location.reload();
                        });
                    });
                }else{
                    var $item = $("<li/>").addClass("d-flex item_cinema no_nearby_cinema").appendTo(nearby_cinemas);
                        var $name=$("<span/>").addClass("cinema_name").text(_l("Aucun cinéma à proximité")).appendTo($item);
                }
                
                // Diviseur (tous les cinémas)
                var $name=$("<div/>").addClass("divider").text(_l("Tous les cinémas")).appendTo($box_list_cinemas);
                var $list = $("<ul/>").addClass("list-unstyled").appendTo($box_list_cinemas);
                    // Tri des cinémas par ordre alphabétique
                    gl_config.chain.sites.sort(function (a, b) {
                        if (a.address.city > b.address.city) {
                            return 1;
                        };
                        if (a.address.city < b.address.city) {
                            return -1;
                        };
                        return 0;
                    });
                    gl_config.chain.sites.forEach(site => {
                        var $item = $("<li/>").addClass("d-flex item_cinema").appendTo($list);
                            var $name=$("<span/>").addClass("cinema_name").text(site.address.city+ " - "+site.name).appendTo($item);
                            // var $name=$("<span/>").addClass("cinema_name").text(site.address.city).appendTo($item);
                        $item.on("click",() => {
                            this.num_cine_selected = site.id;
                            localStorage.setItem("chain_num_cine_selected", site.id);
                            $text.text(site.address.city + " - " + site.name);
                            $box_list_cinemas.remove();
                            // On recharge la page
                            window.location.reload();
                        });
                    });
        });

        $("html").on("click",() => {
            // Si liste existant, on ferme la liste
            if($(".search_box_list_chain_cinemas").length > 0){
                $(".search_box_list_chain_cinemas").remove();
                $div.removeClass("open");
                return;
            }
        });
    }

    

    async $fill_navbar_action_button(iParam){
        // console.log("$fill_navbar_action_button", iParam)
        const $parent = iParam.$parent;
        const data_button = iParam.data;
    
        if(!data_button || !data_button.active){
            return;
        }

        switch(data_button.type){
            case "simple":
                let href = null;
                let target = "_self"
                if(data_button.link.type == "internal" && data_button.link.page_id){
                    href = "#"+data_button.link.page_id;
                }else if(data_button.link.type == "external"){
                    href = data_button.link.url ? data_button.link.url : "#";
                    target = "_blank"
                }else if(data_button.link.type == "file"){
                    href = data_button.link.file_url;
                }else if(data_button.link.type == "auto_program"){
                    href = "#show_prog_pdf"
                }

                var $link=$("<a/>").attr({"href": href, "id":"link_action_button", "target":target}).addClass("pointer").text(_l(data_button.label)).appendTo($parent);
                break;
            case "dropdown":
                var $link=$("<a/>").addClass("dropdown-toggle").attr({"data-bs-toggle":"dropdown", "id":"link_action_button"}).addClass("pointer").text(_l(data_button.label)).appendTo($parent);

                var dropdownItems = []
                if(data_button.dropdown_options && data_button.dropdown_options.items){
                    data_button.dropdown_options.items.forEach(async (item) => {
                        let href = null;
                        let target = "_self"
                        if(item.link.type == "internal" && item.link.page_id){
                            href = "#"+item.link.page_id;
                        }else if(item.link.type == "external"){
                            href = item.link.url ? item.link.url : "#";
                            target = "_blank"
                        }else if(item.link.type == "file"){
                            href = item.link.file_url;
                        }else if(item.link.type == "auto_program"){
                            href = "#show_prog_pdf"
                        }
    
                        dropdownItems.push({
                            text: _l(item.label),
                            href: href,
                            target : target
                        });
                    });
                }
                
                MSDropDown.create({
                    id: "dropdown_action_button",
                    items: dropdownItems,
                }).appendTo($parent);
                break;
            default:
                break;
        }

        // if(data_button.highlight){
        //     $parent.addClass("highlight")
        // }
    }

    updateUserMenu() {
        $("#user_menu_drop_down").remove();
        const $user_menu = this.$m_div.find(".user_menu");

        $user_menu.empty();

        if (!this.auth_token) {
            $user_menu.attr("href", "#login");
            $('<svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="24" fill="white"><path d="M234-276q51-39 114-61.5T480-360q69 0 132 22.5T726-276q35-41 54.5-93T800-480q0-133-93.5-226.5T480-800q-133 0-226.5 93.5T160-480q0 59 19.5 111t54.5 93Zm246-164q-59 0-99.5-40.5T340-580q0-59 40.5-99.5T480-720q59 0 99.5 40.5T620-580q0 59-40.5 99.5T480-440Zm0 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q53 0 100-15.5t86-44.5q-39-29-86-44.5T480-280q-53 0-100 15.5T294-220q39 29 86 44.5T480-160Zm0-360q26 0 43-17t17-43q0-26-17-43t-43-17q-26 0-43 17t-17 43q0 26 17 43t43 17Zm0-60Zm0 360Z" /></svg>').appendTo($user_menu);
        } else {
            $user_menu.removeAttr("href");
            $user_menu.addClass("position-relative p-0")
            // $('<a class="dropdown-toggle" data-bs-toggle="dropdown"><svg xmlns="http://www.w3.org/2000/svg" height="22" viewBox="0 -960 960 960" width="24" fill="white"><path d="M234-276q51-39 114-61.5T480-360q69 0 132 22.5T726-276q35-41 54.5-93T800-480q0-133-93.5-226.5T480-800q-133 0-226.5 93.5T160-480q0 59 19.5 111t54.5 93Zm246-164q-59 0-99.5-40.5T340-580q0-59 40.5-99.5T480-720q59 0 99.5 40.5T620-580q0 59-40.5 99.5T480-440Zm0 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q53 0 100-15.5t86-44.5q-39-29-86-44.5T480-280q-53 0-100 15.5T294-220q39 29 86 44.5T480-160Zm0-360q26 0 43-17t17-43q0-26-17-43t-43-17q-26 0-43 17t-17 43q0 26 17 43t43 17Zm0-60Zm0 360Z" /></svg></a>').appendTo($user_menu);

            var $link=$("<a/>").addClass("dropdown-toggle").attr({"data-bs-toggle":"dropdown", "id":"link_account_avatar"}).appendTo($user_menu);
            // Avatar navbar
            let avatar_path = this.auth_token.user.settings.avatar;
            if(!this.auth_token.user.settings || !this.auth_token.user.settings.avatar){
                avatar_path = "classiques/1.png"
            }
            var $avatar=$("<img/>").addClass("avatar mx-auto").attr({"src":"https://static.monnaie-services.com/www-img/avatar/"+avatar_path}).appendTo($link);

            const dropdownItems = [
                {
                    // icon: "https://static.monnaie-services.com/fontawesome/svgs/regular/user.svg",
                    text: _l("Mon Compte"),
                    href: "#account",
                },
                "",
                {
                    // icon: "https://static.monnaie-services.com/fontawesome/svgs/regular/right-from-bracket.svg",
                    text: _l("Deconnexion"),
                    href: "##logout",
                },
            ];
            MSDropDown.create({
                id: "user_menu_drop_down",
                items: dropdownItems,
            }).appendTo($user_menu);
        }
    }

    hideNav() {
        const desktopNav = $("#nav");
        const mobileNav = $("#mobile-nav");
        const container = $("#page_container");
        if (!is_on_mobile()) {
            desktopNav.show();
            mobileNav.hide();
            container.on("scroll", function () {
                // console.log("scrolltop", container.scrollTop());
                if (container.scrollTop() > 70) {
                    desktopNav.css("top", "-400px");
                }
                if (container.scrollTop() < 80) {
                    desktopNav.css("top", "0px");
                }
            });
        } else {
            // desktopNav.hide();
            desktopNav.remove();
            mobileNav.show();
        }
    }

    manageSideBar() {
        const sideBar = $(".sidebar");
        const hideSidebarButton = $("#cross");
        const showSideBarButton = $("#hamburger");
        const mobileSideBar = $(".mobile-sidebar");
        const searchbar = this.inputContainer;
        const showMobileSideBarButton = $("#mobile-hamburger");
        if (!is_on_mobile()) {
            showSideBarButton.on("click", function (event) {
                sideBar.show();
                event.stopPropagation();
                
                sideBar.find("a").on("click", function () {
                    // sideBar.hide();
                    if(!$(this).hasClass("btn-toggle")){
                    sideBar.hide();
                        $(".collapse").each((i,e) => {
                            $(e).removeClass("show");
                        })
                    }
                });

                hideSidebarButton.on("click", function () {
                    sideBar.hide();
                });

                $(document).on("click", function (event) {
                    // if (
                    //     !$(event.target).closest(".sidebar").length &&
                    //     !$(event.target).is("#hamburger")
                    // ) {
                    //     sideBar.hide();
                    // }
                });
            });
        } else {
            showMobileSideBarButton.on("click", function (event) {
                // mobileSideBar.show();
                mobileSideBar.removeClass("d-none");
                mobileSideBar.addClass("d-flex");
                if (searchbar) {
                    searchbar.hide();
                }
                event.stopPropagation();
            });

            mobileSideBar.find("a").on("click", function () {
                // console.log($(this).hasClass("btn-toggle"))
                if(!$(this).hasClass("btn-toggle")){
                    // mobileSideBar.hide();
                    mobileSideBar.removeClass("d-none");
                    mobileSideBar.removeClass("d-flex");
                    $(".collapse").each((i,e) => {
                        $(e).removeClass("show");
                    })
                }
            });

            // $(document).on("click", function (event) {
            //     if (!$(event.target).closest(".mobile-sidebar li").length) {
            //         mobileSideBar.hide();
            //     }
            // });
        }
    }

    searchInput(events) {
        const self = this;
        if (!events) {
            $("li a#search").remove();
            return;
        }
        const moviesData = events.map((event) => {
            return {
                id: event.id,
                title: event.title,
            };
        });

        const inputResults = this.resultList;
        const inputsearchbar = this.searchMovieInput;
        const clickTarget = this.inputContainer;

        $(".li_search").on("click", function (e) {
            e.stopPropagation();
            clickTarget.toggle()
        });

        $(document).on("click", function (event) {
            if (
                !$(event.target).closest(clickTarget).length &&
                !$(event.target).hasClass("fa-magnifying-glass") &&
                !$(event.target).hasClass("mobile-nav")
            ) {
                inputsearchbar.val("");
                clickTarget.hide();
            }
        });

        this.searchMovieInput.on("input", (event) => {
            inputResults.empty();
            let filteredMovies = [];

            const searchQuery = event.target.value.toLowerCase();
            if (searchQuery === "") {
                return;
            }

            moviesData.forEach((movie) => {
                let movie_title = movie.title;
                movie_title = movie_title.replaceAll(" ","_").toLowerCase();
                movie_title = movie_title.replaceAll("'","").toLowerCase();
                movie_title = movie_title.replaceAll('"',"").toLowerCase();
                movie_title = movie_title.replaceAll(":","").toLowerCase();
                movie_title = movie_title.replaceAll("!","").toLowerCase();
                movie_title = movie_title.replaceAll("?","").toLowerCase();
                movie_title = movie_title.replaceAll(",","").toLowerCase();
                movie_title = movie_title.replaceAll(";","").toLowerCase();
                movie_title = movie_title.replaceAll("=","").toLowerCase();
                movie_title = movie_title.replaceAll("+","").toLowerCase();
                movie_title = movie_title.replaceAll("*","").toLowerCase();
                movie_title = movie_title.replaceAll("/","").toLowerCase();
                movie_title = movie_title.replaceAll("(","").toLowerCase();
                movie_title = movie_title.replaceAll(")","").toLowerCase();
                movie_title = movie_title.replaceAll("[","").toLowerCase();
                movie_title = movie_title.replaceAll("]","").toLowerCase();
                movie_title = movie_title.replaceAll("#","").toLowerCase();
                movie_title = movie_title.replaceAll("@","").toLowerCase();
                movie_title = movie_title.replaceAll("&","_").toLowerCase();
                movie_title = movie_title.replaceAll("à","a").toLowerCase();
                movie_title = movie_title.replaceAll("ù","u").toLowerCase();
                movie_title = movie_title.replaceAll("ü","u").toLowerCase();
                movie_title = movie_title.replaceAll("ï","i").toLowerCase();
                movie_title = movie_title.replaceAll("é","e").toLowerCase();
                movie_title = movie_title.replaceAll("è","e").toLowerCase();
                movie_title = movie_title.replaceAll("ë","e").toLowerCase();
                movie_title = movie_title.replaceAll("ö","o").toLowerCase();
                movie_title = movie_title.replaceAll("ô","o").toLowerCase();

                if(movie_title.includes(searchQuery)){
                    filteredMovies.push(movie)
                }
            })

            // Afficher les résultats filtrés
            if (filteredMovies.length === 0) {
                $("<li/>")
                    .text("Aucun film ne correspond à votre recherche")
                    .addClass("result-item")
                    .appendTo(this.resultList);
            } else {
                filteredMovies.forEach((movie) => {
                    const resultsContentContainer = $("<div/>")
                        .addClass("results-content-container")
                        .appendTo(this.resultList);
                    $("<a/>")
                        .addClass("fa-solid fa-ticket")
                        .appendTo(resultsContentContainer);
                    const listItem = $("<li/>")
                        .text(movie.title)
                        .attr("data-id", movie.id)
                        .addClass(is_on_mobile() ? "mobile-result-items" : "result-item")
                        .appendTo(resultsContentContainer)
                        .on("click", function () {
                            const movieId = $(this).attr("data-id");
                            inputsearchbar.val("");
                            $(this).remove();
                            window.location.href = `#showmovie?id=${movieId}`;

                            if (window.location.href.includes("showmovie")) {
                                // Comportement spécifique à la page 1
                                window.location.href = `#showmovie?id=${movieId}`;
                                window.location.reload();
                            }
                        });
                });
            }
        });

        $(document).on("click", function (event) {
            if (!$(event.target).closest(clickTarget).length) {
                $("#search-movie-input").val("");
                $(this.resultList).empty();
                is_on_mobile()
                    ? $(".mobile-result-items").remove()
                    : $(".result-item").remove();
            }
        });
    }

    switchFooter() {
        const desktopFooter = $(".footer");

        if (!is_on_mobile()) {
            desktopFooter.show();
            $(".mobile-app-footer").remove();
        } else {
            desktopFooter.remove();
            if(gl_mobile_app){
                $(".mobile-app-footer").show();
                $("nav #box_user_menu").remove();
                $("nav #box_basket").remove();
            }else{
                // $(".mobile-app-footer").remove();
                $(".mobile-app-footer").addClass("navigator-web");
                if(gl_config.stage == "local"){
                    $(".mobile-app-footer").css({"bottom":"20px"});
                }else{
                    $(".mobile-app-footer").css({"bottom":"120px"});
                }
            }
        }
    }

    ModalContacte() {
        console.log("ModalContacte - gl_ems_config contact", gl_ems_config);

        const contactCinema = gl_ems_config?.data_cinema.email;
        const contactMS = "contact@ticketingcine.com";
    
        const contactModal = new MSModal({
            showHeader: false,
            html: `
                <div class="container mt-1">
                    <div class="border-0">
                        <h3 class="text-center mb-4 modal-title-color">Contactez-nous</h3>
                        <p class="">
                            Si vous souhaitez des renseignements sur les <span class="fw-bold">séances</span>, veuillez contacter le <span class="modal-color-text">cinéma</span>.
                        </p>
                        <p class="">
                            Si vous souhaitez des renseignements sur les <span class="fw-bold">paiements</span>, contactez l'<span class="modal-color-text">administrateur du site</span>.
                        </p>
                        <div class="mb-3">
                            <label for="contact-select" class="form-label fw-bold">Qui souhaitez-vous contacter ?</label>
                            <!-- Conteneur où MSSelect sera inséré -->
                            <div id="contact-select-container"></div>
                        </div>
                    </div>
                </div>
            `,
            option: {
                dialog: { class: "modal-dialog-centered" }
            },
            backdrop: "static",
            keyboard: false,
            buttons: [
                {
                    title: _l("Annuler"),
                    class: "btn bg-danger",
                    action: () => console.log("Modal fermé sans envoi")
                },
                {
                    title: _l("Envoyer"),
                    class: "btn",
                    preventClose: false,
                    action: () => {
                        const selectedContact = $("#contact-select").val();
                        if (selectedContact) {
                            window.location.href = `mailto:${selectedContact}`;
                        } else {
                            console.warn("Aucun destinataire sélectionné !");
                        }
                    }
                }
            ]
        });
    
        contactModal.open();

        new MSSelect({
            parent: "#contact-select-container",
            select: {
                id: "contact-select",
                class: "form-select text-dark",
            },
            options: {
                data: [
                    { value: "", text: "Choisissez un destinataire" },
                    { value: contactCinema, text: "Cinéma" },
                    { value: contactMS, text: "Administrateur du site" }
                ],
                selected: ""
            }
        }).$create();
    }
}